import { Footer } from "@scuf/common";
import { Slide, ToastContainer } from "react-toastify";
import ConectionStatus from "../../components/conection-status/conectionStatus";

export default function FooterToast({ className }) {
  ConectionStatus();
  return (
    <>
      <Footer className={className}>
        <Footer.Item href="#">Terms & Conditions</Footer.Item>
        <Footer.Item href="#">Privacy Policy</Footer.Item>
        <ToastContainer
          pauseOnFocusLoss={false}
          transition={Slide}
          hideProgressBar={false}
          autoClose={2000}
          closeOnClick={false}
          closeButton={false}
          newestOnTop={true}
          theme={"dark"}
        />
      </Footer>
    </>
  );
}
